module.exports = __webpack_public_path__ + "static/media/people11.3fee5320.jpeg";